import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { STEPS } from '../../../../redux/box-builder/box-builder.constants';
import { selectBackButton } from '../../../../redux/box-builder/box-builder.actions';
import { currentBoxesQuantitySelector, isEditBoxBuilderItemsIdSelector } from '../../../../redux/box-builder/box-builder.selectors';
import SelectCartAddonItemsHeader from './select-cart-addon-items-header';
const mapStateToProps = createStructuredSelector({
  isEditMode: isEditBoxBuilderItemsIdSelector,
  boxesCount: currentBoxesQuantitySelector
});
const mapDispatchToProps = dispatch => ({
  onBackClick: () => {
    dispatch(selectBackButton(STEPS.SELECT_ADDONS_FOR_BOX));
  }
});
export default connect(mapStateToProps, mapDispatchToProps)(SelectCartAddonItemsHeader);